// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1sqi9","signatureBlock":"Footer_signatureBlock__t9pOi","signature":"Footer_signature__2WLZ9"};